import script from "./TressCheckoutManualAddressOption.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressCheckoutManualAddressOption.vue?vue&type=script&lang=ts&setup=true"

import "./TressCheckoutManualAddressOption.vue?vue&type=style&index=0&id=a150cd42&lang=scss"

const __exports__ = script;

export default __exports__